import "./App.css";

import AppRoutes from "./AppRoutes";

import BackdropLoader from "./components/common/BackdropLoader";
import { useSelector, useDispatch } from "react-redux";
import { fetchConfigsAsync } from "./redux/features/configSlice";
import { refreshProfileAsync } from "./redux/features/authSlice";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import OrganizationMetadata from "./components/common/OrganizationMetadata";

function App() {
   const backdropLoading = useSelector((state) => state.helper.backdropLoading);
   const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const dispatch = useDispatch();

   useEffect(() => {
      // Fetch global configs on initial app load
      dispatch(fetchConfigsAsync());
      if (isLoggedIn) {
         dispatch(refreshProfileAsync());
      }
   }, [dispatch, isLoggedIn]);

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <OrganizationMetadata />

      {backdropLoading && <BackdropLoader />}

      <AppRoutes />
    </>
  );
}

export default App;
